module.exports = __webpack_public_path__ + "img/border-inner.050ac171.svg";